module.exports = __webpack_public_path__ + "img/vertical_4_2_8011.32d68ca0.png";